<div class="container">
  <app-game-clicker-background [replayCounter]="replayCounter"
    [started]="started" [game]="game"
    [mode]="mode"
    (completed)="completed($event)">
  </app-game-clicker-background>
  <app-responsive-popup caption="Zoek!" *ngIf="showIntro" [color]="'orange'">
    <div class="content">
      <div class="content-text" [innerHtml]="introText"></div>
    </div>
    <div class="start-buttons">
      <div class="start-button-beginner">
        <app-button-start (click)="start('beginner')"
          [subTitle]="captionBeginner">start</app-button-start>
      </div>
      <div class="start-button-expert">
        <app-button-start (click)="start('expert')"
          [subTitle]="captionExpert">start</app-button-start>
      </div>
    </div>
  </app-responsive-popup>

  <app-responsive-popup caption="Zoek!" *ngIf="showComplete" [color]="'yellow'">
    <app-game-completed [game]="game" (close)="exit()" [enableReplay]="true"
      (replay)="replay()">
      {{resultText}}
    </app-game-completed>
  </app-responsive-popup>
</div>
